// src/components/AdminDashboard.jsx
import React from "react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { RiArrowRightSLine } from "react-icons/ri";
import { getRequest } from "../../helpers/api.helper";
import { heightOptions } from "../../utils/constants";
import Navbar from "./Components/Navbar";

const QuickSearch2 = () => {
  const { id, name } = useParams(); // Get 'id' and 'pageName' from URL
  const [searchTerm, setSearchTerm] = useState("");
  const [modalData, setModalData] = useState<any>(null);

  const [searchTerm2, setSearchTerm2] = useState("");
  const [modalData2, setModalData2] = useState<any>(null);

  const [searchTerm3, setSearchTerm3] = useState("");
  const [modalData3, setModalData3] = useState<any>(null);
  const navigate = useNavigate();
  // Add gender selection
  const [selectedGender, setSelectedGender] = useState("");

  const [city, setCity] = useState([]);
  const [education, setEducation] = useState([]);
  const [annualIncome, setAnnualIncome] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [caste, setCaste] = useState([]);
  const [subcaste, setSubcaste] = useState([]);

  // Initialize with "Any" as default for all fields
  const [selectedOptions, setSelectedOptions] = useState<any>({
    Religion_Preferences: ["Any"],
    Caste_Preferences: ["Any"],
    Sub_Caste_Preferences: ["Any"],
    Mother_Toungue_Preferences: ["Any"],
    Marital_Status_Preferences: ["Any"],
    children_PreferenceOptions: ["Any"],
    Created_by_preference: ["Any"],
    Physical_status_preference: ["Any"],
    Eating_habits_preference: ["Any"],
  });

  const [selectedOptions2, setSelectedOptions2] = useState<any>({
    Education_Preferences: ["Any"],
    Occupation_Preference: ["Any"],
    Job_Location_Preference: ["Any"],
    Anuual_Income_Preference: ["Any"],
    Partner_Family_Preference: ["Any"],
    Setelled_Location_Preference: ["Any"],
  });

  const [selectedOptions3, setSelectedOptions3] = useState<any>({
    Country_Preference: ["Any"],
    State_Preference: ["Any"],
    City_Preference: ["Any"],
    Citizenship_Preference: ["Any"],
  });

  const defaultAgeMin = 18;
  const defaultAgeMax = 60;
  const defaultHeightMin = "4.0";
  const defaultHeightMax = "7.0";

  // Range inputs for age and height
  const [ageRange, setAgeRange] = useState({
    min: defaultAgeMin,
    max: defaultAgeMax,
  });
  const [heightRange, setHeightRange] = useState({
    min: defaultHeightMin,
    max: defaultHeightMax,
  });

  // Age dropdown options (individual values)
  const ageOptions = [
    { value: 18, label: "18 years" },
    { value: 19, label: "19 years" },
    { value: 20, label: "20 years" },
    { value: 21, label: "21 years" },
    { value: 22, label: "22 years" },
    { value: 23, label: "23 years" },
    { value: 24, label: "24 years" },
    { value: 25, label: "25 years" },
    { value: 26, label: "26 years" },
    { value: 27, label: "27 years" },
    { value: 28, label: "28 years" },
    { value: 29, label: "29 years" },
    { value: 30, label: "30 years" },
    { value: 31, label: "31 years" },
    { value: 32, label: "32 years" },
    { value: 33, label: "33 years" },
    { value: 34, label: "34 years" },
    { value: 35, label: "35 years" },
    { value: 36, label: "36 years" },
    { value: 37, label: "37 years" },
    { value: 38, label: "38 years" },
    { value: 39, label: "39 years" },
    { value: 40, label: "40 years" },
    { value: 41, label: "41 years" },
    { value: 42, label: "42 years" },
    { value: 43, label: "43 years" },
    { value: 44, label: "44 years" },
    { value: 45, label: "45 years" },
    { value: 46, label: "46 years" },
    { value: 47, label: "47 years" },
    { value: 48, label: "48 years" },
    { value: 49, label: "49 years" },
    { value: 50, label: "50 years" },
    { value: 51, label: "51 years" },
    { value: 52, label: "52 years" },
    { value: 53, label: "53 years" },
    { value: 54, label: "54 years" },
    { value: 55, label: "55 years" },
    { value: 56, label: "56 years" },
    { value: 57, label: "57 years" },
    { value: 58, label: "58 years" },
    { value: 59, label: "59 years" },
    { value: 60, label: "60 years" },
    { value: 61, label: "61 years" },
    { value: 62, label: "62 years" },
    { value: 63, label: "63 years" },
    { value: 64, label: "64 years" },
    { value: 65, label: "65 years" },
    { value: 66, label: "66 years" },
    { value: 67, label: "67 years" },
    { value: 68, label: "68 years" },
    { value: 69, label: "69 years" },
    { value: 70, label: "70 years" },
    { value: 71, label: "71 years" },
    { value: 72, label: "72 years" },
    { value: 73, label: "73 years" },
    { value: 74, label: "74 years" },
    { value: 75, label: "75 years" },
    { value: 76, label: "76 years" },
    { value: 77, label: "77 years" },
    { value: 78, label: "78 years" },
    { value: 79, label: "79 years" },
    { value: 80, label: "80 years" },
  ];

  // Selected age and height values
  const [selectedAgeMin, setSelectedAgeMin] = useState(defaultAgeMin);
  const [selectedAgeMax, setSelectedAgeMax] = useState(defaultAgeMax);
  const [selectedHeightMin, setSelectedHeightMin] = useState(defaultHeightMin);
  const [selectedHeightMax, setSelectedHeightMax] = useState(defaultHeightMax);

  const dropdownOptions: any = {
    Religion_Preferences: [
      { value: "hindu", label: "Hindu" },
      { value: "muslim", label: "Muslim" },
      { value: "christian", label: "Christian" },
      { value: "sikh", label: "Sikh" },
      { value: "buddhist", label: "Buddhist" },
      { value: "jain", label: "Jain" },
      { value: "parsi", label: "Parsi" },
      { value: "other", label: "Other" },
    ],
    Caste_Preferences: [
      ...caste.map((caste: any) => ({
        value: caste.caste,
        label: caste.caste,
      })),
    ],
    Sub_Caste_Preferences: [
      ...subcaste.map((caste: any) => ({
        value: caste.sub_caste,
        label: caste.sub_caste,
      })),
    ],
    Mother_Toungue_Preferences: [
      { value: "bengali", label: "Bengali" },
      { value: "english", label: "English" },
      { value: "hindi", label: "Hindi" },
      { value: "kannada", label: "Kannada" },
      { value: "marathi", label: "Marathi" },
      { value: "tamil", label: "Tamil" },
      { value: "telugu", label: "Telugu" },
    ],
    Marital_Status_Preferences: [
      { value: "neverMarried", label: "Never Married" },
      { value: "awaitingDivorce", label: "Awaiting Divorce" },
      { value: "divorced", label: "Divorced" },
      { value: "widow", label: "Widowed" },
    ],
    children_PreferenceOptions: [
      { value: "no_children", label: "No children" },
      { value: "want_children", label: "Want children" },
      { value: "has_children", label: "Has children" },
      { value: "not_sure_yet", label: "Not sure yet" },
    ],
    Created_by_preference: [
      { value: "self", label: "Self" },
      { value: "father", label: "Father" },
      { value: "mother", label: "Mother" },
      { value: "friend", label: "Friend" },
      { value: "relatives", label: "Relatives" },
      { value: "sister", label: "Sister" },
      { value: "brother", label: "Brother" },
    ],
    Physical_status_preference: [
      { value: "normal", label: "Normal" },
      { value: "physically_challenged", label: "Physically Challenged" },
    ],
    Eating_habits_preference: [
      { value: "vegetarian", label: "Vegetarian" },
      { value: "non_vegetarian", label: "Non-Vegetarian" },
      { value: "eggetarian", label: "Eggetarian" },
      { value: "jain", label: "Jain" },
    ],
  };

  const dropdownOptions2: any = {
    Education_Preferences: [
      ...education.map((education: any) => ({
        value: education.education,
        label: education.education,
      })),
    ],
    Occupation_Preference: [
      ...occupation.map((occupation: any) => ({
        value: occupation.occupation,
        label: occupation.occupation,
      })),
    ],
    Job_Location_Preference: [
      ...city.map((job_location: any) => ({
        value: job_location.city,
        label: job_location.city,
      })),
    ],
    Anuual_Income_Preference: [
      ...annualIncome.map((annual_income: any) => ({
        value: annual_income.annual_income,
        label: annual_income.annual_income,
      })),
    ],
    Partner_Family_Preference: [
      { value: "Joint_Family", label: "Joint Family" },
      { value: "Nuclear_Family", label: "Nuclear Family" },
      { value: "Family-Oriented_Partner", label: "Family-Oriented Partner" },
      { value: "Independent_Partner", label: "Independent Partner" },
      { value: "Living_with_Parents", label: "Living with Parents" },
    ],
    Setelled_Location_Preference: [
      ...city.map((job_location: any) => ({
        value: job_location.city,
        label: job_location.city,
      })),
    ],
  };

  const dropdownOptions3: any = {
    Country_Preference: [
      ...country.map((job_location: any) => ({
        value: job_location.country,
        label: job_location.country,
      })),
    ],
    State_Preference: [
      ...state.map((job_location: any) => ({
        value: job_location.state,
        label: job_location.state,
      })),
    ],
    City_Preference: [
      ...city.map((job_location: any) => ({
        value: job_location.city,
        label: job_location.city,
      })),
    ],
    Citizenship_Preference: [
      { value: "Indian", label: "Indian" },
      { value: "NRI", label: "NRI" },
    ],
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getRequest(`/common/all`);
        if (response.success) {
          setCity(response.data.city);
          setState(response.data.state);
          setEducation(response.data.education);
          setAnnualIncome(response.data.annualIncome);
          setOccupation(response.data.occupation);
          setCountry(response.data.country);
          setCaste(response.data.caste);
          setSubcaste(response.data.subCaste);
        }
      } catch (error) {
        console.error(`Error fetching data:`, error);
      }
    };

    fetchData();
  }, []);

  const openModal = (key: any) =>
    setModalData({ key, options: dropdownOptions[key] });
  const closeModal = () => setModalData(null);

  const openModal2 = (key: any) =>
    setModalData2({ key, options: dropdownOptions2[key] });
  const closeModal2 = () => setModalData2(null);

  const openModal3 = (key: any) =>
    setModalData3({ key, options: dropdownOptions3[key] });
  const closeModal3 = () => setModalData3(null);

  useEffect(() => {
    if (modalData) {
      setSearchTerm("");
    }
  }, [modalData]);

  useEffect(() => {
    if (modalData2) {
      setSearchTerm2("");
    }
  }, [modalData2]);

  useEffect(() => {
    if (modalData3) {
      setSearchTerm3("");
    }
  }, [modalData3]);

  const handleCheckboxChange = (event: any, option: any, key: any) => {
    const { checked } = event.target;
    const currentOptions = selectedOptions[key] || [];

    if (checked) {
      const updatedSelectedOptions = currentOptions
        .filter((value: any) => value !== "Any")
        .concat(option.value);
      setSelectedOptions({ ...selectedOptions, [key]: updatedSelectedOptions });
    } else {
      const updatedSelectedOptions = currentOptions.filter(
        (value: any) => value !== option.value
      );
      if (updatedSelectedOptions.length === 0) {
        setSelectedOptions({ ...selectedOptions, [key]: ["Any"] });
      } else {
        setSelectedOptions({
          ...selectedOptions,
          [key]: updatedSelectedOptions,
        });
      }
    }
  };

  const handleSelectAllChange = (event: any, key: any) => {
    const { checked } = event.target;
    if (checked) {
      setSelectedOptions((prevSelectedOptions: any) => ({
        ...prevSelectedOptions,
        [key]: dropdownOptions[key].map((option: any) => option.value),
      }));
    } else {
      setSelectedOptions((prevSelectedOptions: any) => ({
        ...prevSelectedOptions,
        [key]: ["Any"],
      }));
    }
  };

  const handleCheckboxChange2 = (event: any, option: any, key: any) => {
    const { checked } = event.target;
    const currentOptions = selectedOptions2[key] || [];

    if (checked) {
      const updatedSelectedOptions = currentOptions
        .filter((value: any) => value !== "Any")
        .concat(option.value);
      setSelectedOptions2({
        ...selectedOptions2,
        [key]: updatedSelectedOptions,
      });
    } else {
      const updatedSelectedOptions = currentOptions.filter(
        (value: any) => value !== option.value
      );
      if (updatedSelectedOptions.length === 0) {
        setSelectedOptions2({ ...selectedOptions2, [key]: ["Any"] });
      } else {
        setSelectedOptions2({
          ...selectedOptions2,
          [key]: updatedSelectedOptions,
        });
      }
    }
  };

  const handleSelectAllChange2 = (event: any, key: any) => {
    const { checked } = event.target;
    if (checked) {
      setSelectedOptions2((prevSelectedOptions2: any) => ({
        ...prevSelectedOptions2,
        [key]: dropdownOptions2[key].map((option: any) => option.value),
      }));
    } else {
      setSelectedOptions2((prevSelectedOptions2: any) => ({
        ...prevSelectedOptions2,
        [key]: ["Any"],
      }));
    }
  };

  const handleCheckboxChange3 = (event: any, option: any, key: any) => {
    const { checked } = event.target;
    const currentOptions = selectedOptions3[key] || [];

    if (checked) {
      const updatedSelectedOptions = currentOptions
        .filter((value: any) => value !== "Any")
        .concat(option.value);
      setSelectedOptions3({
        ...selectedOptions3,
        [key]: updatedSelectedOptions,
      });
    } else {
      const updatedSelectedOptions = currentOptions.filter(
        (value: any) => value !== option.value
      );
      if (updatedSelectedOptions.length === 0) {
        setSelectedOptions3({ ...selectedOptions3, [key]: ["Any"] });
      } else {
        setSelectedOptions3({
          ...selectedOptions3,
          [key]: updatedSelectedOptions,
        });
      }
    }
  };

  const handleSelectAllChange3 = (event: any, key: any) => {
    const { checked } = event.target;
    if (checked) {
      setSelectedOptions3((prevSelectedOptions: any) => ({
        ...prevSelectedOptions,
        [key]: dropdownOptions3[key].map((option: any) => option.value),
      }));
    } else {
      setSelectedOptions3((prevSelectedOptions: any) => ({
        ...prevSelectedOptions,
        [key]: ["Any"],
      }));
    }
  };

  // Handle age min/max selection
  const handleAgeMinChange = (selectedValue: any) => {
    const value = parseInt(selectedValue);
    setSelectedAgeMin(value);
    setAgeRange((prev) => ({ ...prev, min: value }));
  };

  const handleAgeMaxChange = (selectedValue: any) => {
    const value = parseInt(selectedValue);
    setSelectedAgeMax(value);
    setAgeRange((prev) => ({ ...prev, max: value }));
  };

  // Handle height min/max selection
  const handleHeightMinChange = (selectedValue: any) => {
    setSelectedHeightMin(selectedValue);
    setHeightRange((prev) => ({ ...prev, min: selectedValue }));
  };

  const handleHeightMaxChange = (selectedValue: any) => {
    setSelectedHeightMax(selectedValue);
    setHeightRange((prev) => ({ ...prev, max: selectedValue }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (modalData) {
      const allSelected =
        selectedOptions[modalData.key]?.length === modalData.options.length &&
        !selectedOptions[modalData.key]?.includes("Any");
      const checkbox: any = document.getElementById("selectAllCheckbox");
      if (checkbox) {
        checkbox.checked = allSelected;
      }
    }
  }, [selectedOptions, modalData]);

  useEffect(() => {
    if (modalData2) {
      const allSelected2 =
        selectedOptions2[modalData2.key]?.length ===
          modalData2.options.length &&
        !selectedOptions2[modalData2.key]?.includes("Any");
      const checkbox: any = document.getElementById("selectAllCheckbox2");
      if (checkbox) {
        checkbox.checked = allSelected2;
      }
    }
  }, [selectedOptions2, modalData2]);

  useEffect(() => {
    if (modalData3) {
      const allSelected3 =
        selectedOptions3[modalData3.key]?.length ===
          modalData3.options.length &&
        !selectedOptions3[modalData3.key]?.includes("Any");
      const checkbox: any = document.getElementById("selectAllCheckbox3");
      if (checkbox) {
        checkbox.checked = allSelected3;
      }
    }
  }, [selectedOptions3, modalData3]);

  // Check if marital status is "Never Married" to conditionally show children options
  const isNeverMarried =
    selectedOptions.Marital_Status_Preferences?.includes("neverMarried");

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    // Validate gender selection
    if (!selectedGender) {
      alert("Please select a gender to search for.");
      return;
    }

    function processPreferences(preferences: any, defaultValue = "Any") {
      // If preferences is "Any" or empty array, return "Any"
      if (
        !preferences ||
        preferences.length === 0 ||
        (preferences.length === 1 && preferences[0] === "Any")
      ) {
        return "Any";
      }
      // If all items are "Any", return "Any"
      if (preferences.every((item: any) => item === "Any")) {
        return "Any";
      }
      // Filter out "Any" and join the rest
      const filteredPreferences = preferences.filter(
        (item: any) => item !== "Any"
      );
      return filteredPreferences.length > 0
        ? filteredPreferences.join(",")
        : "Any";
    }

    const searchData = {
      gender: selectedGender,
      religionPreferences: processPreferences(
        selectedOptions.Religion_Preferences
      ),
      castePreferences: processPreferences(selectedOptions.Caste_Preferences),
      subCastePreferences: processPreferences(
        selectedOptions.Sub_Caste_Preferences
      ),
      motherTonguePreferences: processPreferences(
        selectedOptions.Mother_Toungue_Preferences
      ),
      maritalStatusPreferences: processPreferences(
        selectedOptions.Marital_Status_Preferences
      ),
      childrenPreferences: isNeverMarried
        ? "no_children"
        : processPreferences(selectedOptions.children_PreferenceOptions),
      ageMin: ageRange.min,
      ageMax: ageRange.max,
      heightMin: heightRange.min,
      heightMax: heightRange.max,
      createdByPreferences: processPreferences(
        selectedOptions.Created_by_preference
      ),
      physicalStatusPreferences: processPreferences(
        selectedOptions.Physical_status_preference
      ),
      eatingHabitsPreferences: processPreferences(
        selectedOptions.Eating_habits_preference
      ),
      educationPreferences: processPreferences(
        selectedOptions2.Education_Preferences
      ),
      occupationPreferences: processPreferences(
        selectedOptions2.Occupation_Preference
      ),
      jobLocationPreferences: processPreferences(
        selectedOptions2.Job_Location_Preference
      ),
      annualIncomePreferences: processPreferences(
        selectedOptions2.Anuual_Income_Preference
      ),
      familyPreferences: processPreferences(
        selectedOptions2.Partner_Family_Preference
      ),
      settledLocationPreferences: processPreferences(
        selectedOptions2.Setelled_Location_Preference
      ),
      countryPreferences: processPreferences(
        selectedOptions3.Country_Preference
      ),
      statePreferences: processPreferences(selectedOptions3.State_Preference),
      cityPreferences: processPreferences(selectedOptions3.City_Preference),
      citizenshipPreferences: processPreferences(
        selectedOptions3.Citizenship_Preference
      ),
    };
    try {
      const params = new URLSearchParams();

      Object.entries(searchData).forEach(([key, value]) => {
        if (value && value !== "Any") {
          params.append(key, value);
        }
      });

      navigate(`/${id}/${name}/search/results?${params.toString()}`, {
        state: { searchData },
      });
    } catch (error) {
      console.error("Error processing search:", error);
      alert("An error occurred while processing your search.");
    }
  };

  const [bureauName, setBureauName] = useState<string>();
  const [navbarLogo, setNavbarLogo] = useState<string>();

  useEffect(() => {
    const fetchBureauDetails = async () => {
      try {
        const response = await getRequest(`/bureau/website/${id}`);
        if (response.success) {
          const { profile } = response.data;
          setBureauName(profile.bureauName);
          setNavbarLogo(profile.navbarLogo);
        }
      } catch (error) {
        console.error("Error fetching bureau details:", error);
      }
    };

    fetchBureauDetails();
  }, []);

  // Helper to get display text for a dropdown
  const getDisplayText = (key: any, options: any, selectedValues: any) => {
    if (
      Array.isArray(selectedValues) &&
      Array.isArray(options) &&
      selectedValues?.length === options?.length
    ) {
      return "Any";
    }
    if (
      selectedValues?.length > 0 &&
      !selectedValues?.every((item: any) => item === "Any")
    ) {
      return options
        ?.filter((opt: any) => selectedValues?.includes(opt.value))
        .map((opt: any) => opt.label)
        .join(", ");
    }
    return "Any";
  };

  return (
    <div className="flex flex-col bg-gray-50 min-h-screen mt-8 sm:mt-20">
      <Navbar bureauName={bureauName} navbarLogo={navbarLogo} />

      <div className="flex-1 p-4 mb-20 mt-16 max-w-7xl mx-auto w-full">
        <form onSubmit={handleSubmit} className="space-y-8">
          {/* Gender Selection */}
          <section className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6">
            <div className="text-center pb-4">
              <button
                type="button"
                className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white p-3 rounded-lg hover:from-orange-600 hover:to-red-600 transition-all font-semibold shadow-md"
              >
                * Select Gender to Search For *
              </button>
            </div>

            <div>
              <label className="block text-red-500 font-medium mb-3">
                Gender
              </label>
              <div className="grid grid-cols-2 gap-4">
                <button
                  type="button"
                  onClick={() => setSelectedGender("male")}
                  className={`p-4 rounded-lg border-2 transition-all ${
                    selectedGender === "male"
                      ? "border-blue-500 bg-blue-50 text-blue-700"
                      : "border-gray-300 hover:border-gray-400"
                  }`}
                >
                  <div className="text-center">
                    <div className="text-2xl mb-2">👨</div>
                    <div className="font-semibold">Male</div>
                    <div className="text-sm text-gray-600">
                      Search for Male profiles
                    </div>
                  </div>
                </button>

                <button
                  type="button"
                  onClick={() => setSelectedGender("female")}
                  className={`p-4 rounded-lg border-2 transition-all ${
                    selectedGender === "female"
                      ? "border-pink-500 bg-pink-50 text-pink-700"
                      : "border-gray-300 hover:border-gray-400"
                  }`}
                >
                  <div className="text-center">
                    <div className="text-2xl mb-2">👩</div>
                    <div className="font-semibold">Female</div>
                    <div className="text-sm text-gray-600">
                      Search for Female profiles
                    </div>
                  </div>
                </button>
              </div>

              {selectedGender && (
                <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg max-w-md">
                  <p className="text-green-700 text-center font-medium">
                    Searching for{" "}
                    {selectedGender === "male" ? "Male" : "Female"} profiles
                  </p>
                </div>
              )}
            </div>
          </section>

          {/* Age & Height Range - Side by Side on Desktop */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Age Range */}
            <section className="bg-white border border-gray-100 rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 p-6">
              <div className="flex items-center space-x-3 mb-5">
                <div className="w-10 h-10 bg-gradient-to-r from-red-500 to-pink-500 rounded-xl flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <div>
                  <h2 className="text-lg font-bold text-gray-800">
                    Age Preference
                  </h2>
                  <p className="text-sm text-gray-500">
                    Select your preferred age range
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-600 mb-1">
                    From Age
                  </label>
                  <div className="relative">
                    <select
                      value={selectedAgeMin}
                      onChange={(e) => handleAgeMinChange(e.target.value)}
                      className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 appearance-none bg-white"
                    >
                      {ageOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <svg
                        className="w-5 h-5 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div>
                  <label className="block text-sm text-gray-600 mb-1">
                    To Age
                  </label>
                  <div className="relative">
                    <select
                      value={selectedAgeMax}
                      onChange={(e) => handleAgeMaxChange(e.target.value)}
                      className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 appearance-none bg-white"
                    >
                      {ageOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <svg
                        className="w-5 h-5 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-center text-sm text-gray-500 mt-3">
                Selected:{" "}
                <span className="font-semibold text-red-600">
                  {selectedAgeMin}
                </span>{" "}
                –{" "}
                <span className="font-semibold text-pink-600">
                  {selectedAgeMax}
                </span>{" "}
                years
              </p>
            </section>

            {/* Height Range */}
            <section className="bg-white border border-gray-100 rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 p-6">
              <div className="flex items-center space-x-3 mb-5">
                <div className="w-10 h-10 bg-gradient-to-r from-green-500 to-teal-500 rounded-xl flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M7 3v18M17 3v18M7 7h10M7 11h10M7 15h10"
                    />
                  </svg>
                </div>
                <div>
                  <h2 className="text-lg font-bold text-gray-800">
                    Height Preference
                  </h2>
                  <p className="text-sm text-gray-500">
                    Select your preferred height range
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-600 mb-1">
                    From Height
                  </label>
                  <div className="relative">
                    <select
                      value={selectedHeightMin}
                      onChange={(e) => handleHeightMinChange(e.target.value)}
                      className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 appearance-none bg-white"
                    >
                      {heightOptions.map((option, index) => (
                        <option
                          key={`${option.value}-${option.label}-${index}`}
                          value={option.value}
                        >
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <svg
                        className="w-5 h-5 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div>
                  <label className="block text-sm text-gray-600 mb-1">
                    To Height
                  </label>
                  <div className="relative">
                    <select
                      value={selectedHeightMax}
                      onChange={(e) => handleHeightMaxChange(e.target.value)}
                      className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 appearance-none bg-white"
                    >
                      {heightOptions.map((option, index) => (
                        <option
                          key={`${option.value}-${option.label}-${index}`}
                          value={option.value}
                        >
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <svg
                        className="w-5 h-5 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-center text-sm text-gray-500 mt-3">
                Selected:{" "}
                <span className="font-semibold text-green-600">
                  {
                    heightOptions.find((opt) => opt.value === selectedHeightMin)
                      ?.label
                  }
                </span>{" "}
                –{" "}
                <span className="font-semibold text-teal-600">
                  {
                    heightOptions.find((opt) => opt.value === selectedHeightMax)
                      ?.label
                  }
                </span>
              </p>
            </section>
          </div>

          {/* Caste & Religion Preferences */}
          <section className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6">
            <div className="text-center pb-4">
              <button
                type="button"
                className="w-full bg-gradient-to-r from-red-500 to-pink-500 text-white p-3 rounded-lg hover:from-red-600 hover:to-pink-600 transition-all font-semibold shadow-md"
              >
                * Caste &amp; Religion Preferences *
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {Object.keys(dropdownOptions).map((key) => (
                <div key={key}>
                  <label className="block text-red-500 font-medium mb-2 capitalize text-sm">
                    {key.replace(/_/g, " ")}
                  </label>
                  <div
                    className="flex w-full rounded-lg border px-3 border-gray-300 py-3 cursor-pointer hover:shadow-md transition-all"
                    onClick={() => openModal(key)}
                  >
                    <div className="flex items-center justify-between w-full">
                      <span className="text-gray-500 text-sm font-medium truncate">
                        {getDisplayText(
                          key,
                          dropdownOptions[key],
                          selectedOptions[key]
                        )}
                      </span>
                      <RiArrowRightSLine className="text-2xl text-gray-500 ml-2 flex-shrink-0" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Profession & Income Preferences */}
          <section className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6">
            <div className="text-center pb-4">
              <button
                type="button"
                className="w-full bg-gradient-to-r from-green-500 to-teal-500 text-white p-3 rounded-lg hover:from-green-600 hover:to-teal-600 transition-all font-semibold shadow-md"
              >
                * Profession &amp; Income Preferences *
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {Object.keys(dropdownOptions2).map((key) => (
                <div key={key}>
                  <label className="block text-red-500 font-medium mb-2 capitalize text-sm">
                    {key.replace(/_/g, " ")}
                  </label>
                  <div
                    className="flex w-full rounded-lg border px-3 border-gray-300 py-3 cursor-pointer hover:shadow-md transition-all"
                    onClick={() => openModal2(key)}
                  >
                    <div className="flex items-center justify-between w-full">
                      <span className="text-gray-500 text-sm font-medium truncate">
                        {getDisplayText(
                          key,
                          dropdownOptions2[key],
                          selectedOptions2[key]
                        )}
                      </span>
                      <RiArrowRightSLine className="text-2xl text-gray-500 ml-2 flex-shrink-0" />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-5 flex justify-center">
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 max-w-2xl w-full">
                <p className="text-yellow-800 text-sm text-center">
                  💡 <strong>Tip:</strong> Use "Annual Income Preferences"
                  dropdown above for income filtering
                </p>
              </div>
            </div>
          </section>

          {/* Location Preferences */}
          <section className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6">
            <div className="text-center pb-4">
              <button
                type="button"
                className="w-full bg-gradient-to-r from-purple-500 to-indigo-500 text-white p-3 rounded-lg hover:from-purple-600 hover:to-indigo-600 transition-all font-semibold shadow-md"
              >
                * Location Preferences *
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {Object.keys(dropdownOptions3).map((key) => (
                <div key={key}>
                  <label className="block text-red-500 font-medium mb-2 capitalize text-sm">
                    {key.replace(/_/g, " ")}
                  </label>
                  <div
                    className="flex w-full rounded-lg border px-3 border-gray-300 py-3 cursor-pointer hover:shadow-md transition-all"
                    onClick={() => openModal3(key)}
                  >
                    <div className="flex items-center justify-between w-full">
                      <span className="text-gray-500 text-sm font-medium truncate">
                        {getDisplayText(
                          key,
                          dropdownOptions3[key],
                          selectedOptions3[key]
                        )}
                      </span>
                      <RiArrowRightSLine className="text-2xl text-gray-500 ml-2 flex-shrink-0" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Submit */}
          <div className="text-center pb-3">
            <button
              type="submit"
              className="w-full sm:w-1/2 lg:w-1/3 mx-auto bg-gradient-to-r from-red-500 to-pink-500 text-white p-3 rounded-lg hover:from-red-600 hover:to-pink-600 transition-all font-semibold shadow-md"
            >
              Search Profiles
            </button>
          </div>
        </form>

        {/* Modal 1 */}
        {modalData && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
              <h2 className="text-lg font-bold mb-4 capitalize text-center">
                Select {modalData.key}
              </h2>
              <div className="flex items-center space-x-2 mb-4">
                <input
                  id="selectAllCheckbox"
                  type="checkbox"
                  checked={
                    selectedOptions[modalData.key]?.length ===
                      dropdownOptions[modalData.key].length &&
                    !selectedOptions[modalData.key]?.includes("Any")
                  }
                  onChange={(e) => handleSelectAllChange(e, modalData.key)}
                  className="form-checkbox h-4 w-4 text-red-600"
                />
                <label className="block text-gray-700">Any</label>
              </div>
              <input
                type="text"
                className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
                placeholder={`Search ${modalData.key}`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
                {modalData.options
                  .filter((option: any) =>
                    option.label
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  )
                  .map((option: any, index: any) => (
                    <div key={index}>
                      <div className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          checked={
                            selectedOptions[modalData.key]?.includes(
                              option.value
                            ) && option.value !== "Any"
                          }
                          onChange={(e) =>
                            handleCheckboxChange(e, option, modalData.key)
                          }
                          className="form-checkbox h-4 w-4 text-red-600"
                        />
                        <label className="block text-gray-700">
                          {option.label}
                        </label>
                      </div>
                      <hr className="border-gray-200 mt-3 mb-3" />
                    </div>
                  ))}
              </div>
              <button
                className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
                onClick={closeModal}
              >
                Continue
              </button>
            </div>
          </div>
        )}

        {/* Modal 2 */}
        {modalData2 && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
              <h2 className="text-lg font-bold mb-4 capitalize text-center">
                Select {modalData2.key}
              </h2>
              <div className="flex items-center space-x-2 mb-4">
                <input
                  id="selectAllCheckbox2"
                  type="checkbox"
                  checked={
                    selectedOptions2[modalData2.key]?.length ===
                      dropdownOptions2[modalData2.key].length &&
                    !selectedOptions2[modalData2.key]?.includes("Any")
                  }
                  onChange={(e) => handleSelectAllChange2(e, modalData2.key)}
                  className="form-checkbox h-4 w-4 text-red-600"
                />
                <label className="block text-gray-700">Any</label>
              </div>
              <input
                type="text"
                className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
                placeholder={`Search ${modalData2.key}`}
                value={searchTerm2}
                onChange={(e) => setSearchTerm2(e.target.value)}
              />
              <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
                {modalData2.options
                  .filter((option: any) =>
                    option.label
                      .toLowerCase()
                      .includes(searchTerm2.toLowerCase())
                  )
                  .map((option: any, index: any) => (
                    <div key={index}>
                      <div className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          checked={
                            selectedOptions2[modalData2.key]?.includes(
                              option.value
                            ) && option.value !== "Any"
                          }
                          onChange={(e) =>
                            handleCheckboxChange2(e, option, modalData2.key)
                          }
                          className="form-checkbox h-4 w-4 text-red-600"
                        />
                        <label className="block text-gray-700">
                          {option.label}
                        </label>
                      </div>
                      <hr className="border-gray-200 mt-3 mb-3" />
                    </div>
                  ))}
              </div>
              <button
                className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
                onClick={closeModal2}
              >
                Continue
              </button>
            </div>
          </div>
        )}

        {/* Modal 3 */}
        {modalData3 && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
              <h2 className="text-lg font-bold mb-4 capitalize text-center">
                Select {modalData3.key}
              </h2>
              <div className="flex items-center space-x-2 mb-4">
                <input
                  id="selectAllCheckbox3"
                  type="checkbox"
                  checked={
                    selectedOptions3[modalData3.key]?.length ===
                      dropdownOptions3[modalData3.key].length &&
                    !selectedOptions3[modalData3.key]?.includes("Any")
                  }
                  onChange={(e) => handleSelectAllChange3(e, modalData3.key)}
                  className="form-checkbox h-4 w-4 text-red-600"
                />
                <label className="block text-gray-700">Any</label>
              </div>
              <input
                type="text"
                className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
                placeholder={`Search ${modalData3.key}`}
                value={searchTerm3}
                onChange={(e) => setSearchTerm3(e.target.value)}
              />
              <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
                {modalData3.options
                  .filter((option: any) =>
                    option.label
                      .toLowerCase()
                      .includes(searchTerm3.toLowerCase())
                  )
                  .map((option: any, index: any) => (
                    <div key={index}>
                      <div className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          checked={
                            selectedOptions3[modalData3.key]?.includes(
                              option.value
                            ) && option.value !== "Any"
                          }
                          onChange={(e) =>
                            handleCheckboxChange3(e, option, modalData3.key)
                          }
                          className="form-checkbox h-4 w-4 text-red-600"
                        />
                        <label className="block text-gray-700">
                          {option.label}
                        </label>
                      </div>
                      <hr className="border-gray-200 mt-3 mb-3" />
                    </div>
                  ))}
              </div>
              <button
                className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
                onClick={closeModal3}
              >
                Continue
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuickSearch2;
